import { SET_FILTER } from './constants'

export function setFilter(id, filter) {
    return {
        type: SET_FILTER,
        id,
        filter
    }
}


// WEBPACK FOOTER //
// ./src/actions/filters.js